import { post } from './requests.js'

export const getPredict = (payload) =>
  post(['people-model', 'predict'], { transformPayload: false }, payload)
